import React from "react";
import { BiPlusCircle } from "react-icons/bi";
// import Button from "@mui/material/Button";
import { routePaths } from "../../baseLayout/SidebarMenu";
import { useRedirect } from "react-admin";
import { PERMISSIONS } from "../../roles";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import FdButton from "../UIComponents/Button/FdButton";

const NewEventButton = () => {
  const redirect = useRedirect();

  // permissions
  const canManageEvent = useHasPermissions(PERMISSIONS.CAN_MANAGE_EVENT);

  return (
    <>
      {canManageEvent && (
        <FdButton
          variant="contained"
          color="primary"
          size="medium"
          startIcon={<BiPlusCircle />}
          onClick={() => {
            redirect(`/${routePaths.NEW_EVENT}`);
          }}
          ButtonName="Create new event"
         />
      )}
    </>
  );
};

export default NewEventButton;
